import { render, staticRenderFns } from "./UserClasses.vue?vue&type=template&id=31ea3f6c&"
import script from "./UserClasses.vue?vue&type=script&lang=js&"
export * from "./UserClasses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports